import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-positive"
}
const _hoisted_2 = { key: 0 }


import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import date from 'quasar/src/utils/date/date.js';;
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
import { useAuthStore } from '~store/auth/authModule';
import { useMainStore } from '@/store';

import { Slot } from '~store/ecohospital/types';

const __default__ = { name: 'AppointmentPage' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const ecoStore = useEcoHospitalStore();
const authStore = useAuthStore();

const { user } = storeToRefs(authStore);

const appointmentDate = ref<string | null>(null);
const appointmentTime = ref('');
const calendar = ref<Slot[]>([]);
const phone = ref('');
const sending = ref(false);
const appointmentMessage = ref('');

onMounted(async () => {
  if (!user.value?.show_appointment) return;

  try {
    const availableSlots = await ecoStore.getAppointmenCalendar();

    if (availableSlots.length) calendar.value = availableSlots;

    if (user.value?.tel) phone.value = user.value.tel;
  } catch (err) {
    console.error(err);
  }
});

const availableDays = computed(() => calendar.value.map((i) => date.formatDate(i.date, 'YYYY/MM/DD')));

const availableTimes = computed(() => {
  const calendarIndex = availableDays.value.findIndex(
    (i) => i === appointmentDate.value,
  );

  if (calendarIndex > -1) {
    return calendar.value[calendarIndex].times
      .split(',')
      .map((i) => ({
        label: i.split(':').slice(0, 2).join(':'),
        value: i,
      }));
  }

  return [];
});

const createAppointment = async () => {
  if (!appointmentTime.value) {
    useMainStore().showMessage('Укажите желаемое время приема!');
    return;
  }

  if (phone.value.includes('_')) {
    useMainStore().showMessage('Неверный формат номера телефона!');
    return;
  }

  const cleaned = phone.value.replace(/\D/g, '');

  const params = {

    date: date.formatDate(
      appointmentDate.value ?? '',
      'YYYY-MM-DD',
    ),

    time: appointmentTime.value.trim(),

    tel: `+${cleaned}`,

  };

  try {
    sending.value = true;

    const [appointment] = await ecoStore.createAppointment(params);

    if (appointment.err_text.includes('Ваша заявка принята')) {
      appointmentMessage.value = appointment.err_text;

      const busySlotIndex = availableTimes.value.findIndex(
        (i) => i.value === appointmentTime.value,
      );

      if (busySlotIndex > -1) availableTimes.value.splice(busySlotIndex, 1);
    }
  } catch (err) {
    console.error(err);
  } finally {
    sending.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "gos-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "gos-header" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h6" }, " Запись на прием ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption" }, " Выберите дату и время ", -1)),
          (appointmentMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(appointmentMessage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "row q-col-gutter-md" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_date, {
            minimal: "",
            modelValue: appointmentDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appointmentDate).value = $event)),
            options: availableDays.value
          }, null, 8, ["modelValue", "options"]),
          (appointmentDate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_btn_toggle, {
                  modelValue: appointmentTime.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appointmentTime).value = $event)),
                  options: availableTimes.value,
                  "toggle-color": "primary"
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_q_input, {
                  modelValue: phone.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phone).value = $event)),
                  label: "Телефон",
                  mask: "+7 (###) ### - ####",
                  type: "tel"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "phone" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_q_btn, {
                  class: "gos-btn",
                  color: "primary",
                  icon: "event_available",
                  label: "Записаться",
                  loading: sending.value,
                  disable: !appointmentTime.value,
                  onClick: createAppointment
                }, null, 8, ["loading", "disable"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})